import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import PropertiesCatalog from "@/components/PropertiesCatalog";
import { Suspense } from "react";

export function PropertiesCatalogPage() {
  return (
    <div className="min-h-screen bg-parchment">
      <Navbar />
      <main className="pt-24">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mb-12">
            <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-4 block">
              Explora Nuestro Catálogo
            </span>
            <h1 className="text-5xl md:text-8xl font-display font-black uppercase text-ink leading-none italic mb-6">
              Propiedades <br /> 
              <span className="text-stroke-ink">Excepcionales</span>
            </h1>
            <p className="text-xl font-serif italic text-ink/60 max-w-2xl leading-relaxed">
              Descubra una selección curada de activos inmobiliarios en las ubicaciones más dinámicas de Latinoamérica. Filtrado por expertos, para inversores y buscadores de distinción.
            </p>
          </div>

          <Suspense fallback={
            <div className="py-40 text-center">
              <div className="animate-pulse text-terracotta font-display font-black text-2xl uppercase tracking-[0.5em]">Cargando Catálogo...</div>
            </div>
          }>
            <PropertiesCatalog />
          </Suspense>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PropertiesCatalogPage;
